var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "eye_svg__st0",
    d: "M42.6 17.3c-6.3 0-11.5 5.1-11.5 11.5s5.1 11.5 11.5 11.5S54 35.1 54 28.7s-5.1-11.4-11.4-11.4zm0-17.2C23.5.1 7.1 12 .5 28.7c6.6 16.8 22.9 28.7 42.1 28.7 19.1 0 35.4-11.9 42.1-28.7C78 12 61.7.1 42.6.1zm0 47.8c-10.6 0-19.1-8.6-19.1-19.1S32 9.6 42.6 9.6s19.1 8.6 19.1 19.1-8.6 19.2-19.1 19.2z"
  })));
}
export default SvgEye;